import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, formValueSelector } from 'redux-form'
import { Button, Card } from 'react-bootstrap'

import * as actions from '../../../actions'
import { FORM_ANULACION_EGRESO } from '../../../../../config/forms'

import StatusModal from
  '../../../../Forms/SharedComponents/containers/StatusModal'

class AnulacionEgreso1 extends Component {
  render () {
    const {
      numero,
      onSubmit,
      invalid,
      anulacionEgresoShowDeleteModal,
      anulacionEgresoDeleteResponse,
      onPrev,
      hideAnulacionEgresoDeleteMessageModal
    } = this.props

    return (
      <div>
        <StatusModal
          show={anulacionEgresoShowDeleteModal}
          onClick={hideAnulacionEgresoDeleteMessageModal}
          errorMessage={anulacionEgresoDeleteResponse}
          extraErrorMessage={null}
        />
        <br />
        <Card className='shadow bg-white rounded'>
          <Card.Header>
            <Card.Title> ¿Desea anular el egreso de la CP? </Card.Title>
          </Card.Header>
          <Card.Body>
            <h1><strong>{numero}</strong></h1>
          </Card.Body>
        </Card>
        <br />
        <div>
          <Button onClick={() => onPrev()}
            variant='primary'
            size='lg'
          >Atras</Button>{'  '}
          <Button
            size='lg'
            variant='danger'
            onClick={() => onSubmit()}
            disabled={invalid}
          >Anular Egreso</Button>
        </div>
      </div>
    )
  };
};

const selector = formValueSelector(FORM_ANULACION_EGRESO)

const mapStateToProps = (state) => ({
  numero: selector(state, 'numero'),
  invalid: isInvalid(FORM_ANULACION_EGRESO)(state),
  anulacionEgresoDeleteResponse: state.calado.anulacionEgresoDeleteResponse,
  anulacionEgresoShowDeleteModal: state.calado.anulacionEgresoShowDeleteModal
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_ANULACION_EGRESO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(AnulacionEgreso1))
